import { decorateUrl } from 'components/common/UTMscript'
import { push } from 'connected-react-router'
import { handleMarkAsWatched, playNextVideoAction, SetQualityVideo } from 'pages/Course/store'
import { connect } from 'react-redux'
import UI from './UI'

const mapStateToProps = ({ course }) => ({
  CourseId: course.Course?.Id,
  Image: course.Course?.Image,
  currentVideoId: course.currentVideo?.Id,
  currentVideoLink: course.currentVideo?.Link,
  selectedQuality: course.quality,
  wasAlreadyWatched: course.currentVideo?.WasAlreadyWatched
})

const mapDispatchToProps = dispatch => ({
  handleMarkAsWatched: () => dispatch(handleMarkAsWatched()),
  playNextVideo: () => dispatch(playNextVideoAction()),
  onQualitySelected: quality => dispatch(SetQualityVideo(quality)),
  goTo: link => dispatch(push(decorateUrl(link)))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
